import React, { useState } from 'react';
import { useContent } from '../content/ContentContext';

export default function Contact() {
  const { contactPage, site } = useContent();
  const { hero, faqs } = contactPage;

  const [form, setForm] = useState({ name: '', phone: '', age: '', type: '学校 / 机构' });
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (!form.name.trim()) { setError('请填写称呼'); return; }
    if (!form.phone.trim()) { setError('请填写联系电话'); return; }
    setSubmitting(true);
    try {
      const r = await fetch('/api/leads', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name: form.name, phone: form.phone, role: form.type, childAge: form.age, source: '联系页' }),
      });
      const j = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(j.error || '提交失败，请稍后再试');
      setSubmitted(true);
    } catch (err) { setError(err.message); } finally { setSubmitting(false); }
  };

  return (
    <div>
      {/* 页头 */}
      <section className="page-top pb-16">
        <div className="container-x text-center">
          <div className="eyebrow mb-3 reveal">{hero.eyebrow}</div>
          <h1 className="text-4xl md:text-6xl font-semibold tracking-tight reveal" style={{ color: 'var(--ink)', transitionDelay: '0.05s' }}>
            {hero.title}
          </h1>
          <p className="mx-auto mt-6 max-w-2xl text-lg md:text-xl leading-relaxed reveal" style={{ color: 'var(--muted)', transitionDelay: '0.1s' }}>
            {hero.desc}
          </p>
        </div>
      </section>

      <section className="pb-24 md:pb-32">
        <div className="container-x mx-auto max-w-xl">
          {submitted ? (
            <div className="text-center reveal py-16">
              <h3 className="text-3xl font-semibold tracking-tight" style={{ color: 'var(--ink)' }}>提交成功</h3>
              <p className="mt-4 text-lg" style={{ color: 'var(--muted)' }}>感谢 {form.name} 的信任，我们会尽快与你联系。</p>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-6 reveal">
              <div>
                <span className="mb-2 block text-[14px] font-medium" style={{ color: 'var(--ink)' }}>合作类型</span>
                <div className="flex gap-3">
                  {['学校 / 机构', '渠道 / 合作方'].map((t) => (
                    <button type="button" key={t} onClick={() => setForm({ ...form, type: t })}
                      className="flex-1 py-3 text-[15px] font-medium transition-colors cursor-pointer"
                      style={{
                        borderRadius: '12px',
                        border: `1px solid ${form.type === t ? 'var(--accent)' : 'var(--line)'}`,
                        color: form.type === t ? 'var(--accent)' : 'var(--ink)',
                        background: form.type === t ? 'rgba(0,113,227,0.06)' : 'transparent',
                      }}>
                      {t}
                    </button>
                  ))}
                </div>
              </div>
              <div>
                <label htmlFor="name" className="mb-2 block text-[14px] font-medium" style={{ color: 'var(--ink)' }}>称呼</label>
                <input id="name" type="text" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="怎么称呼你" className="form-input" />
              </div>
              <div>
                <label htmlFor="phone" className="mb-2 block text-[14px] font-medium" style={{ color: 'var(--ink)' }}>联系电话</label>
                <input id="phone" type="tel" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} placeholder="方便联系的手机号" className="form-input" />
              </div>
              <div>
                <label htmlFor="age" className="mb-2 block text-[14px] font-medium" style={{ color: 'var(--ink)' }}>预计应用场景（选填）</label>
                <select id="age" value={form.age} onChange={(e) => setForm({ ...form, age: e.target.value })} className="form-input cursor-pointer">
                  <option value="">请选择</option>
                  <option value="school">学校信息课 / 社团</option>
                  <option value="museum">科技馆 / 少年宫</option>
                  <option value="training">培训机构课程包</option>
                </select>
              </div>
              <button type="submit" disabled={submitting} className="btn btn-blue w-full" style={{ opacity: submitting ? 0.6 : 1 }}>
                {submitting ? '提交中…' : '提交合作咨询'}
              </button>
              {error && <p className="text-center text-[14px]" style={{ color: '#d70015' }}>{error}</p>}
              <p className="text-center text-[13px]" style={{ color: 'var(--muted)' }}>我们承诺保护你的隐私，信息仅用于机构合作沟通。</p>
            </form>
          )}

          {/* 联系方式 */}
          <div className="mt-16 grid grid-cols-2 gap-y-6 text-[15px]" style={{ borderTop: '1px solid var(--line)', paddingTop: '2.5rem' }}>
            {[['电话', site.phone], ['邮箱', site.email], ['地址', site.address], ['时间', site.hours]].map(([k, v]) => (
              <div key={k}>
                <div className="text-[13px]" style={{ color: 'var(--muted)' }}>{k}</div>
                <div className="mt-1 font-medium" style={{ color: 'var(--ink)' }}>{v}</div>
              </div>
            ))}
          </div>

          {/* 常见问题 */}
          <div className="mt-16">
            <h3 className="text-2xl font-semibold tracking-tight" style={{ color: 'var(--ink)' }}>常见问题</h3>
            <div className="mt-6">
              {(faqs || []).map((f, i) => (
                <div key={i} className="py-6" style={{ borderTop: '1px solid var(--line)' }}>
                  <div className="text-[16px] font-medium" style={{ color: 'var(--ink)' }}>{f.q}</div>
                  <div className="mt-2 text-[15px] leading-relaxed" style={{ color: 'var(--muted)' }}>{f.a}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}